<template>
    <v-card elevation="2">
        <v-card-title>FakeGame {{ index }}</v-card-title>
        <v-card-text>
            <v-row>
                <v-col class="col-5-5 mobile-player">
                    <v-row class="swap-column">
                        <v-col md="4" class="pr-0">
                            <v-autocomplete
                                v-model="player1"
                                :items="players"
                                :hint="hint1"
                                persistent-hint
                                :disabled="!canEdit"
                                item-text="name"
                                item-value="name"
                                label="Player 1"
                                return-object
                                single-line
                                @change="player1 = playerSelected($event, 1)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col md="4" class="pr-0">
                            <v-autocomplete
                                v-model="player2"
                                :items="players"
                                :hint="hint2"
                                :disabled="!canEdit"
                                persistent-hint
                                item-text="name"
                                item-value="name"
                                label="Player 2"
                                return-object
                                single-line
                                @change="player2 = playerSelected($event, 2)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col md="4" class="pr-0">
                            <v-autocomplete
                                v-model="player3"
                                :items="players"
                                :hint="hint3"
                                persistent-hint
                                :disabled="!canEdit"
                                item-text="name"
                                item-value="name"
                                label="Player 3"
                                return-object
                                single-line
                                @change="player3 = playerSelected($event, 3)"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col align="center" class="versus-box mobile-versus" md="1" justify="center">
                    <h3>VS</h3>
                    <h3>-</h3>
                </v-col>
                <v-col justify="end" class="col-5-5 mobile-player">
                    <v-row class="swap-column">
                        <v-col class="pr-0">
                            <v-autocomplete
                                v-model="player4"
                                :items="players"
                                :hint="hint4"
                                persistent-hint
                                :disabled="!canEdit"
                                item-text="name"
                                item-value="name"
                                label="Player 4"
                                return-object
                                single-line
                                @change="player4 = playerSelected($event, 4)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col class="pr-0">
                            <v-autocomplete
                                v-model="player5"
                                :items="players"
                                :hint="hint5"
                                persistent-hint
                                :disabled="!canEdit"
                                item-text="name"
                                item-value="name"
                                label="Player 5"
                                return-object
                                single-line
                                @change="player5 = playerSelected($event, 5)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col class="pr-0">
                            <v-autocomplete
                                v-model="player6"
                                :items="players"
                                :hint="hint6"
                                persistent-hint
                                :disabled="!canEdit"
                                item-text="name"
                                item-value="name"
                                label="Player 6"
                                return-object
                                single-line
                                @change="player6 = playerSelected($event, 6)"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row v-if="elo1 && elo2">
                <v-col md="6" align="center">
                    Team elo: {{elo1}}
                </v-col>
                <v-col md="6" align="center">
                    Team elo: {{elo2}}
                </v-col>
            </v-row>
            <v-row v-if="(score1 || score2) && checkPlayers">
                <v-col md="6" align="center">
                    Score shift: {{scoreShift1}}
                </v-col>
                <v-col md="6" align="center">
                    Score shift: {{scoreShift2}}
                </v-col>
            </v-row>
            <h3 class="my-3">Score</h3>
            <v-row>
                <div class="score-box mx-3">
                    <div class="score">
                        <v-select v-model="score1" :items="scores" dense :disabled="!canEdit">
                        </v-select>
                    </div>
                    <div class="score">
                        <v-select v-model="score2" :items="scores" dense :disabled="!canEdit">
                        </v-select>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="gameDone()" class="mr-2" :disabled="!canEdit">
                        Done
                    </v-btn>
                    <v-btn color="primary" @click="sortTeams()" :disabled="!canEdit"> Sort </v-btn>
                </div>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Utils from '../utils'
export default {
    name: "TeamCard",
    props: {
        index: {
            type: Number,
            default: 0,
        },
        game: {
            type: Object,
            default: null
        },
        canEdit: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            player1: {},
            player2: {},
            player3: {},
            player4: {},
            player5: {},
            player6: {},
            hint1: "",
            hint2: "",
            hint3: "",
            hint4: "",
            hint5: "",
            hint6: "",
            score1: 0,
            score2: 0,
            scores: [0, 1, 2],
            elo1: 0,
            elo2: 0,
            scoreShift1: 20,
            scoreShift2: -20
        };
    },
    watch: {
        score1() {
            if (this.score1 == 1) this.score2 = 2;
            else if (this.score1 == 2 && this.score2 == 2) this.score2 = 1;
            if(this.checkPlayers) this.calculateScore()
        },
        score2() {
            if (this.score2 == 1) this.score1 = 2;
            else if (this.score2 == 2 && this.score1 == 2) this.score1 = 1;
            if(this.checkPlayers) this.calculateScore()
        },
        checkPlayers(){
            if(this.checkPlayers){
                console.log("checkPLayers")
                this.countTeamElos()
            }
        },
        game: {
            deep: true,
            handler(){
                this.player1 = this.game.players[0]
                this.player2 = this.game.players[1]
                this.player3 = this.game.players[2]
                this.player4 = this.game.players[3]
                this.player5 = this.game.players[4]
                this.player6 = this.game.players[5]
                this.score1 = this.game.team1_score;
                this.score2 = this.game.team2_score;
            }
        }
    },
    methods: {
        sortTeams() {
            if(!this.checkPlayers){
                console.log("Cannot sort, not enough players")
                return
            }
            let average = (this.player1.elo + this.player2.elo + this.player3.elo + this.player4.elo + this.player5.elo + this.player6.elo) / 6
            let allPlayers = [this.player1, this.player2, this.player3, this.player4, this.player5, this.player6]
            let teamCombos = []
            for(let a = 1; a < 7; a++){
                for(let b = a+1; b < 7; b++){
                    for(let c = b+1; c < 7; c++){
                        teamCombos.push([this["player" + a], this['player' + b], this['player'+c]])
                    }
                }
            }

            teamCombos = teamCombos.sort((a,b) => {
                return Math.abs(average - ((a[0].elo + a[1].elo + a[2].elo) / 3)) - Math.abs(average - ((b[0].elo + b[1].elo + b[2].elo) / 3))
            })
            this.player1 = teamCombos[0][0]
            this.player2 = teamCombos[0][1]
            this.player3 = teamCombos[0][2]
            allPlayers = allPlayers.filter(player => player.id != this.player1.id && player.id != this.player2.id && player.id != this.player3.id)
            console.log(allPlayers)
            this.player4 = allPlayers[0]
            this.player5 = allPlayers[1]
            this.player6 = allPlayers[2]
            this.hint1 = teamCombos[0][0].elo.toString() + (teamCombos[0][0].rank ? "*": "")
            this.hint2 = teamCombos[0][1].elo.toString() + (teamCombos[0][1].rank ? "*": "")
            this.hint3 = teamCombos[0][2].elo.toString() + (teamCombos[0][2].rank ? "*": "")
            this.hint4 = allPlayers[0].elo.toString() + (allPlayers[0].rank ? "*": "")
            this.hint5 = allPlayers[1].elo.toString() + (allPlayers[1].rank ? "*": "")
            this.hint6 = allPlayers[2].elo.toString() + (allPlayers[2].rank ? "*": "")
            this.countTeamElos()
            // console.log("SORTED", average, teamCombos)
        },
        gameDone() {
            let total = this.score1 + this.score2;
            if (total >= 2 && total < 4 && this.checkPlayers) {
                let date = new Date()
                date.setTime(date.getTime() - (60000*date.getTimezoneOffset()))
                let game = {
                    id: this.game ? this.game.id : this.$store.state.games[0].id + 1,
                    location_repr: {
                        id: 4,
                        name: "Palloiluhalli nurmikko",
                        longitude: "25.47261",
                        latitude: "65.05467"
                    },
                    players: [
                        {...this.player1, team:1},
                        {...this.player2, team:1},
                        {...this.player3, team:1},
                        {...this.player4, team:2},
                        {...this.player5, team:2},
                        {...this.player6, team:2}
                    ],
                    teams: [
                        {
                            name: this.player4.name + this.player5.name + this.player6.name,
                            side: 2
                        },
                        {
                            name: this.player1.name + this.player2.name + this.player3.name,
                            side: 1
                        }
                    ],
                    date: date.toISOString(),
                    name: "FakeGame " + this.index,
                    description: "",
                    team1_score: this.score1,
                    team2_score: this.score2,
                    state: 3,
                    season: this.$store.state.currentSeason,
                    location: 4
                }
                this.$emit("gameDone", { game: game, index: this.index });
                // calculate new elos
            }
        },
        playerSelected(player, index) {
            for(let i = 1; i < 7; i++){
                if(i == index) continue
                if(this['player' + i]?.id == player.id) return {}
            }
            if(this.checkPlayers) this.countTeamElos()
            this['hint' + index] = player.elo.toString() + (player.rank ? "*": "")
            return {...player}
        },
        countTeamElos(){
            this.elo1 = Math.round((this.player1.elo + this.player2.elo + this.player3.elo) / 3)
            this.elo2 = Math.round((this.player4.elo + this.player5.elo + this.player6.elo) / 3)
            this.calculateScore()
        },
        calculateScore(){
            // calculate score shift to
            console.log("Calculate new scores")
            let eloChange = (this.score1 * Utils.calculateEloChange(this.elo1, this.elo2, true)
                    + this.score2 * Utils.calculateEloChange(this.elo1, this.elo2, false))
            console.log(eloChange)
            if(eloChange < 0) eloChange = Math.ceil(eloChange)
            else eloChange = Math.floor(eloChange)
            this.scoreShift1 = eloChange < 0 ? eloChange - 1: eloChange
            this.scoreShift2 = -1 * (eloChange > 0 ? eloChange + 1: eloChange)
        }
    },
    computed: {
        ...mapGetters({
            players: 'sortedPlayers'
            }),
        checkPlayers() {
            if (
                this.player1.id &&
                this.player2.id &&
                this.player3.id &&
                this.player4.id &&
                this.player5.id &&
                this.player6.id
            )
                return true;
            else return false;
        },
    },
    mounted(){
        if(this.game){
            this.player1 = this.game.players[0]
            this.player2 = this.game.players[1]
            this.player3 = this.game.players[2]
            this.player4 = this.game.players[3]
            this.player5 = this.game.players[4]
            this.player6 = this.game.players[5]
            this.score1 = this.game.team1_score;
            this.score2 = this.game.team2_score;
        }
    }
};
</script>

<style lang="scss" scoped>
.versus-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.score-box {
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.score {
    width: 64px !important;
    margin-right: 24px;
}
@media (min-width: 960px){
    .col-5-5{
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: 45.8%;
        max-width: 45.8%;
    }
}
@media (max-width: 960px){
    .swap-column{
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .mobile-player{
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: 45%;
        max-width: 45%;
    }
    .mobile-versus{
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: 10%;
        max-width: 10%;
        padding: 0;
    }
}
</style>